// extracted by mini-css-extract-plugin
export default {"vehicleButton":"vehicle-cell_vehicleButton__8cQE9"};